import { gql } from '@apollo/client'
import { STORE_REGION_FRAGMENT } from '../fragments'

export const GET_COMPANY_REGION = gql`
  query GetCompanyRegion($regionId: ID!) {
    companyRegion(regionId: $regionId) {
      ...StoreRegion
    }
  }
  ${STORE_REGION_FRAGMENT}
`
